import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
import { IsNumber } from 'class-validator';
import { DemoExtensionStatus } from '../enum';
let ExtendDemoResponse = /*#__PURE__*/(() => {
  let ExtendDemoResponse = class ExtendDemoResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", String)], ExtendDemoResponse.prototype, "status", void 0);
  ExtendDemoResponse = __decorate([AppRequest('users', 'company-demos/extend', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId']
  }), ModelId("ExtendDemoResponse") // auto-generated by generate-model-ids
  ], ExtendDemoResponse);
  return ExtendDemoResponse;
})();
export { ExtendDemoResponse };
// check is case-insensitive, but note that returned value letters will be as saved in the database!
let ExtendDemoRequest = /*#__PURE__*/(() => {
  let ExtendDemoRequest = class ExtendDemoRequest extends Model {
    static {
      this.Response = ExtendDemoResponse;
    }
  };
  __decorate([Expose(), IsNumber(), __metadata("design:type", Number)], ExtendDemoRequest.prototype, "companyId", void 0);
  __decorate([Expose(), __metadata("design:type", String)], ExtendDemoRequest.prototype, "feedback", void 0);
  ExtendDemoRequest = __decorate([AppRequest('users', 'company-demos/extend', {
    httpMethod: AppRequestMethod.POST,
    requiredAccessData: ['userId']
  }), ModelId("ExtendDemoRequest") // auto-generated by generate-model-ids
  ], ExtendDemoRequest);
  return ExtendDemoRequest;
})();
export { ExtendDemoRequest };